import gql from 'graphql-tag';

export const GENERATE_ASSET_LIST_MUTATION = gql`
  mutation generateAssetListPdf($uuid: String!) {
    generateAssetListPdf(uuid: $uuid)
  }
`;
